import { render, staticRenderFns } from "./HeroGraphicText.vue?vue&type=template&id=c5e4b68c&"
import script from "./HeroGraphicText.vue?vue&type=script&lang=js&"
export * from "./HeroGraphicText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports